if (typeof CostPerServing !== 'function') {
	class CostPerServing extends HTMLElement {
		constructor() {
			super();

			this.elements = {};
			this.state = {
				daysPerPack: 0,
				templates: {
					one: '',
					few: '',
					other: '',
				},
			};

			this.handleQuantityChange = this.handleQuantityChange.bind(this);
		}

		connectedCallback() {
			this.cacheElements();
			this.readConfig();
			this.bindEvents();
			this.updateSupply(this.getQuantity());
		}

		disconnectedCallback() {
			this.destroy();
		}

		cacheElements() {
			this.elements.supply = this.querySelector('[data-js-cps-supply]');
			this.elements.productRoot = this.closest('[data-js-product-component]');
			this.elements.qtyInput = this.elements.productRoot
				? this.elements.productRoot.querySelector('[data-js-product-quantity] .qty-selector')
				: null;
		}

		readConfig() {
			this.state.daysPerPack = Number(this.dataset.daysPerPack) || 0;
			this.state.templates = {
				one: this.dataset.supplyOne || '',
				few: this.dataset.supplyFew || this.dataset.supplyOther || '',
				other: this.dataset.supplyOther || '',
			};
		}

		bindEvents() {
			this.elements.qtyInput?.addEventListener('change', this.handleQuantityChange);
			this.elements.qtyInput?.addEventListener('input', this.handleQuantityChange);
		}

		destroy() {
			this.elements.qtyInput?.removeEventListener('change', this.handleQuantityChange);
			this.elements.qtyInput?.removeEventListener('input', this.handleQuantityChange);
			this.elements = {};
		}

		handleQuantityChange() {
			this.updateSupply(this.getQuantity());
		}

		/**
		 * @returns {number}
		 */
		getQuantity() {
			const raw = this.elements.qtyInput ? parseInt(this.elements.qtyInput.value, 10) : 1;

			return Number.isFinite(raw) && raw > 0 ? raw : 1;
		}

		/**
		 * @param {number} quantity
		 */
		updateSupply(quantity) {
			if (!this.elements.supply || this.state.daysPerPack <= 0) return;

			const daysRounded = Math.floor(this.state.daysPerPack * quantity);

			if (daysRounded < 1) {
				this.elements.supply.hidden = true;

				return;
			}

			this.elements.supply.hidden = false;
			this.elements.supply.textContent = this.formatSupply(daysRounded);
		}

		/**
		 * @param {number} count
		 * @returns {string}
		 */
		formatSupply(count) {
			const template = this.state.templates[this.getPluralForm(count)] || this.state.templates.other;

			return template.replace(/__COUNT__/g, String(count));
		}

		/**
		 * @param {number} count
		 * @returns {'one' | 'few' | 'other'}
		 */
		getPluralForm(count) {
			const locale = (document.documentElement.lang || window.Shopify?.locale || 'en').toLowerCase();

			if (locale.startsWith('ro')) {
				if (count === 1) return 'one';

				const mod100 = count % 100;

				if (count === 0 || (count !== 1 && mod100 >= 1 && mod100 <= 19)) return 'few';

				return 'other';
			}

			return count === 1 ? 'one' : 'other';
		}
	}

	if (typeof customElements.get('cost-per-serving') === 'undefined') {
		customElements.define('cost-per-serving', CostPerServing);
	}
}
